const STORAGE_KEY = 'lfour-returning';

/** Deliberately outlives logout — it records the browser, never the session. */
export function markReturningVisitor(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* blocked storage only costs one redirect */
  }
}

export function hasVisitedBefore(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) !== null;
  } catch {
    return false;
  }
}

export function clearReturningVisitor(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* nothing to clear */
  }
}
